import PropTypes from 'prop-types';

import {RqGetAllProducts} from '../../../reactQuery/apis';

const OrderSummary = ({product, appliedPromoCode}) => {
  const {data: allProducts} = RqGetAllProducts();

  const products = Array.isArray(product) ? product : [product];

  const capitalize = str => str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();

  const toDropboxRawUrl = (url = '') =>
    url.replace('www.dropbox.com', 'dl.dropboxusercontent.com')
      .replace('?dl=0', '');

  const getVariantImage = item => {
    const productData = allProducts?.find(
      p => p.id === item.productId,
    );

    if (!productData) {return '';}

    const selectedVariant = productData.variants?.find(
      v => v.color === item.color,
    );

    if (selectedVariant?.images?.length) {
      return normalizeImageUrl(selectedVariant.images[0]);
    }

    for (const variant of productData.variants || []) {
      if (variant.images?.length) {
        return normalizeImageUrl(variant.images[0]);
      }
    }

    return '';
  };

  const normalizeImageUrl = (url = '') => {
    if (!url) {return '';}

    if (url.includes('dropbox.com')) {
      return url
        .replace('www.dropbox.com', 'dl.dropboxusercontent.com')
        .replace('?dl=0', '');
    }

    return url; 
  };

  return (
    <div>
      {products.map((item, index) => {
        console.log(`Product: ${item.productName}`);
        console.log(`Promo Code: ${item.promocodeInfo?.code || 'None'}`);
        console.log(`Promo Discount Value: %${item.promocodeInfo?.discountValue || 0}`);

        return (
          <div key={index} className={'flex items-start mb-4 w-full lg:p-2 shadow-md'}>
            <div className={'flex w-full'}>
              <div className={'w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-20 lg:h-20'}>
                <img
                  alt={'product'}
                  src={getVariantImage(item)}
                  className={'w-full h-full object-cover rounded-lg'}
                />

              </div>

              <div className={'ml-4 flex flex-col lg:gap-2 gap-1 w-full'}>
                <div className={'flex lg:flex-row flex-col gap-4 justify-evenly'}>
                  <h1 className={'lg:text-base lg:w-1/2 font-bold text-primary-900'}>{capitalize(item.productName)}</h1>
                  <div className={'flex md:gap-7 justify-between md:px-0 px-4'}>
                    <h1 className={'lg:text-base text-center '}>
                      <p className={'font-medium'}>Size </p>
                      {item.size}
                    </h1>
                    <h1 className={'lg:text-base text-center'}>
                      <p className={'font-medium'}>Quantity </p>{item.quantity}
                    </h1>
                  </div>
                  <div className={'flex md:gap-7 mb-4 justify-between md:px-0 px-4'}>
                    <h1 className={'lg:text-base  text-center'}>
                      <p className={'font-medium'}>Price</p>₹{Math.round(item.pricePerUnit)}
                    </h1>
                    <h1 className={'lg:text-base text-center'}>
                      <p className={'font-medium '}>SubTotal</p>₹{Math.round(item.pricePerUnit)*item.quantity}
                    </h1>
                  </div>
                </div>

                {appliedPromoCode && (
                  <div className={'mb-3 p-2 bg-green-50 border border-green-300 rounded text-green-700 text-sm font-medium'}>
    Applied Promo Code: {appliedPromoCode}
                  </div>
                )}

              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

OrderSummary.propTypes = {
  product: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        productId: PropTypes.string,
        productName: PropTypes.string,
        pricePerUnit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        imageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        size: PropTypes.string,
        quantity: PropTypes.number,
        productType: PropTypes.string,
        promoCode: PropTypes.string,
        promocodeInfo: PropTypes.shape({
          code: PropTypes.string,
          discountValue: PropTypes.number,
        }),
      }),
    ),
    PropTypes.shape({
      productId: PropTypes.string,
      productName: PropTypes.string,
      pricePerUnit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      imageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
      size: PropTypes.string,
      quantity: PropTypes.number,
      productType: PropTypes.string,
      promoCode: PropTypes.string,
      promocodeInfo: PropTypes.shape({
        code: PropTypes.string,
        discountValue: PropTypes.number,
      }),
    }),
  ]).isRequired,
  appliedPromoCode: PropTypes.string,
};

export default OrderSummary;
